import api from "./api";
import Swal from "sweetalert2";
let service = {};

service.ahora = function () {
  return api.get('/api/reports/dashboard/ahora').then((res) => res)
}

service.periodo = function (filtro, rango) {
  const params = new URLSearchParams()
  if (rango && rango.inicio && rango.fin) {
    params.set('fechaInicio', rango.inicio)
    params.set('fechaFin', rango.fin)
  } else {
    params.set('filter', filtro || 'day')
  }
  return api.get('/api/reports/dashboard/periodo?' + params.toString()).then((res) => res)
}

service.resumen = function (filtro, rango) {
  const params = new URLSearchParams()
  if (rango && rango.inicio && rango.fin) {
    params.set('fechaInicio', rango.inicio)
    params.set('fechaFin', rango.fin)
  } else {
    params.set('filter', filtro || 'month')
  }
  return api
    .get('/api/reports/dashboard?' + params.toString())
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: "Atención!",
        text: err.data.message,
        icon: "error",
        confirmButtonText: "Enterado",
      });
      return err;
    });
};
service.ventasPorFiltro = function (filtro) {
  return api
    .post("/api/reports/salesByFilters", JSON.stringify(filtro), {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: "Atención!",
        text: err.data.message,
        icon: "error",
        confirmButtonText: "Enterado",
      });
      throw err;
    });
};
service.ventasPorOrden = function (orden) {
  return api
    .get("/api/reports/salesByOrder/" + orden)
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: "Atención!",
        text: err.data.message,
        icon: "error",
        confirmButtonText: "Enterado",
      });
      throw err;
    });
};

service.getSales = async (data) => {
  try {
    console.log(data)
    const { fechaInicio, fechaFin, status = null, busqueda = "", page = 1, itemsPerPage = 10 } = data;
    return await api.get(
      `/api/reports/sales?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&status=${status}&page=${page}&limit=${itemsPerPage}&busqueda=${busqueda}`
    );
  } catch (err) {
    Swal.fire({
      title: "Atención!",
      text: err.data.message,
      icon: "error",
      confirmButtonText: "Enterado",
    });
    throw err;
  }
};

service.clientes = function (data) {
  const {busqueda = "", page = 1, itemsPerPage = 10} = data
  return api
    .get(`/api/reports/clients?page=${page}&limit=${itemsPerPage}&busqueda=${busqueda}`, )
    .then((res) => res)
    .catch((err) => {
      Swal.fire({
        title: "Atención!",
        text: err.data.message,
        icon: "error",
        confirmButtonText: "Enterado",
      });
      throw(err)
    });
};

service.mecanicos = function (data) {
  const {fechaFin,fechaInicio,page = 1, busqueda = "", itemsPerPage = 10 } = data
  return api
    .get(`/api/reports/mechanics?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&page=${page}&busqueda=${busqueda}&limit=${itemsPerPage}`)
    .then((res) => res)
    .catch((err) => {
      console.error(err);
      Swal.fire({
        title: "Atención!",
        text: err.data.message,
        icon: "error",
        confirmButtonText: "Enterado",
      });
      throw err;
    });
};

service.gasto = function () {
  return api
    .get("/api/spend")
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
service.gastoNuevo = function (gasto) {
  return api
    .post("/api/spend/create", gasto)
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
service.gastosByFilter = function (filtros) {
  return api
    .post("/api/spend/getFilter", filtros)
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
service.cortes = function () {
  return api
    .get("/api/dayCut")
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
service.corteUltimo = function (user) {
  return api
    .get("/api/dayCut/getLast/" + user)
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
service.corteNuevo = function (corte) {
  return api
    .post("/api/dayCut/create", corte)
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
service.corteBorrar = function (id) {
  return api
    .put("/api/dayCut/" + id)
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      alert(err.data.message);
    });
};
export default service;
